/*
 * @Description:axios封装
 * @Author: gonghong
 * @Date: 2024-02-20 09:51:45
 * @LastEditTime: 2024-02-27 11:28:38
 */
import Axios from 'axios'

import qs from 'qs'

import Storage from '@/utils/storage'
import { loginoutClear } from '@/utils/auth'
import { createDiscreteApi } from 'naive-ui'
const { message } = createDiscreteApi(['message'])
const pendingMap = new Map()

// 请求结果状态码
const ResultEnum = {
    SUCCESS: 200,
    ERROR: 400,
    PARAM_ERROR: 405,
    SERVER_ERROR: 500,
    NO_PERMISSION: 450,
    CODE_EXPIRE: 443,
    REST_LOGIN: 401,
}

const baseUrl = import.meta.env.VITE_API_BASE_URL
const service = Axios.create({
    baseURL: baseUrl, timeout: 20000,
})
/**
 * @description: request拦截器
 * @return {*}
 */
service.interceptors.request.use(
    config => {
        removePending(config)
        addPending(config)
        return config
    },
    error => {
        Promise.reject(error)
    },
)
/**
 * @description: 响应拦截器
 * @return {*}
 */
service.interceptors.response.use(
    response => {
        removePending(response.config)
        const data = response.data
        const code = data.code
        if (Number(code) === ResultEnum.SUCCESS) {
            return data
        }
        if (Number(code) === ResultEnum.NO_PERMISSION || Number(code) === ResultEnum.CODE_EXPIRE || Number(code) === ResultEnum.REST_LOGIN) {
            // token过期没有权限,需重新登录
            loginoutClear()
            return Promise.resolve(data)
        }
        return Promise.reject('error')
    },
    error => {
        // console.log(3333, error)
        let code = ""
        code  = error?.response?.data?.code
        // console.log(4444, code)
        if (Number(code) === ResultEnum.NO_PERMISSION || Number(code) === ResultEnum.CODE_EXPIRE || Number(code) === ResultEnum.REST_LOGIN) {
            // console.log(5555, code)
            // token过期没有权限,需重新登录
            loginoutClear()
            return Promise.reject(error?.response?.data?.msg)
        }
        return Promise.reject(error)
    },
)
/**
 * @description: Axios.request请求
 * @param {*} method 请求方法
 * @param {*} url   请求url
 * @param {*} params 请求参数
 * @param {*} headers 请求头
 * @param {*} options 请求其他参数
 * @return {*}
 */
const request = async(method = '', url, params, headers = {}, options) => {
    if (!url){
        throw new Error('请求url不能为空')
    }
    // axios.request参数
    const config = {
        method,
        url,
        ...options,
    }
    // 添加请求headers得Authorization
    const auth = Storage.getLocal('Authorization')
    config.headers = Object.assign({ Authorization: auth }, headers)
    if (method.toLowerCase() === 'post' || method.toLowerCase() === 'put') {
        config.data = params
    }
    else {
        config.params = params
    }
    return service.request(config).then(res => res).catch(error => Promise.reject(error))
}
/**
 * @description: 获取完整请求接口
 * @param {*} config
 * @return {*}
 */
const getPendingUrl = config => [config.method, config.url, qs.stringify(config.data), qs.stringify(config.params)].join(
    '&',
)
/**
 * @description: 防重复请求操作：添加到队列
 * @param {*} config
 * @return {*}
 */
const addPending = config => {
    const url = getPendingUrl(config)
    config.cancelToken =
        config.cancelToken ||
        new Axios.CancelToken(cancel => {
            if (!pendingMap.has(url)) {
                // 如果 pending 中不存在当前请求，则添加进去
                pendingMap.set(url, cancel)
            }
        })
}
/**
 * @description: 防重复请求操作：请求从队列中删除
 * @param {*} config
 * @return {*}
 */
const removePending = config => {
    const url = getPendingUrl(config)

    if (pendingMap.has(url)) {
        const cancel = pendingMap.get(url)
        cancel && cancel(url)
        pendingMap.delete(url)
    }
}

/**
 * @description: 根据api执行对应接口
 * @param {*} api
 * @param {*} params
 * @param {*} headers
 * @param {*} options
 * @return {*}
 */
async function send(api, params, headers, options){
    return request(api.method, api.url, params, headers, options)
}
export default {
    service, request, send,
}
